import {  Center, Modal, ModalContent, ModalOverlay, Stack, Spinner } from '@chakra-ui/react';
import { FunctionComponent } from 'react';
import BtButton, { ButtonParams } from './BtButton';




export interface SpinnerParams {
    interrupt: ButtonParams

}

interface SpinnerProps {
    interrupt: ButtonParams
    show: boolean
    onClick: () => void
    visible: boolean
}


const BtSpinner: FunctionComponent<SpinnerProps> = ({ show, interrupt, onClick, visible }) => {

    return (<Modal isOpen={show} onClose={() => { }} isCentered size='xl'>
        <ModalOverlay
            bg='rgba(0, 0, 0, 0.6)'
            backdropFilter='auto'
            backdropBlur='2px'
        />
        <ModalContent bg='none'
            backdropFilter='auto'
            backdropBlur='2px'
            boxShadow='none'
            >
            <Center>
                <Stack w='full' spacing={8} direction={['column', 'column']} alignItems='center'>
                    <Spinner color='brand.500' size='xl' />
                   {visible && <BtButton variant='link' size='lg' w='full'{...interrupt} action={() => onClick()} />}
                </Stack>
            </Center>

        </ModalContent>

    </Modal>
    )

}

export default BtSpinner;